/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import InputField from "../../../shared-ui/input-field";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import RadioButtonComponent from "../../../shared-ui/radio-button";
// import "react-accessible-accordion/dist/fancy-example.css";
import _, { isArray, isEmpty } from "lodash";
import Button from "../../../shared-ui/button";
import { handleCreateTestScenarioAPI } from "../../../../services/adminToolServices/createTestScenario";
import { getNeedStateName, getTagsList } from "../../../../utils/getTags";
import SaveTestCasePopup from "../../../shared-ui/popup/admin-save-popup";
import { updateTestScenario } from "../../../../services/adminToolServices/updateTestScenario";
import { formattedText } from "../../../../utils/formattedText";
import MessageStrip from "../../../shared-ui/message-strip";
import { exportData } from "./export-data";
import DifferencePopup from "../../../shared-ui/popup/difference-popup";
import Loader from "../../../shared-ui/loader";
import { handleCheckTestDiffStateAPI } from "../../../../services/adminToolServices/checkStateDifference";
import { msalInstance } from "../../../../core/authentication/entra/msal";

function getAdminEmail(): string {
  const accounts = msalInstance.getAllAccounts();
  if (!accounts?.length) return "";
  const acct = accounts[0];
  const claims: any = acct.idTokenClaims || {};
  return claims?.email || claims?.preferred_username || acct.username || "";
}

const generateUniqueId = require("generate-unique-id");

interface ResultsSectionProps {
  metaResponseProps: any;
  inputProps: any;
  handleViewMode: (testCaseName: string) => void;
  isViewMode: boolean;
  isEditMode?: boolean;
  testCaseName: string;
  creator: string;
  initialInput?: any;
  initialResults?: any;
  isRunLoad: boolean;
  testCaseStatus: boolean;
  testCaseStatusIsSet: boolean;
}

interface ResultsSectionState {
  mainDropdownOptions: any;
  subDropdownOptions: any;
  selectedMainOption: string;
  selectedSubOption: string;
  isMainDropdownOpen: boolean;
  isSubDropdownOpen: boolean;
  tipsData: any;
  foodsData: any;
  productsData: any;
  dataToDisplay: any;
  openList: boolean;
  accordionItemsState: string;
  storageDataState: any;
  metaResponseState: any;
  valueToSearch: string;
  isSaveOpen: boolean;
  tagsListState: any;
  isDuplicateTestCase: boolean;
  currentTestCaseName: string;
  saveButtonType: string;
  isOpenMessageStrip: boolean;
  isDifferenceOpen: boolean;
  initialInputState: any;
  initialResultsState: any;
  isSearch: boolean;
  inputState: any;
  isApiFailed: boolean;
  ApiFailedMessage: string;
}

class ResultsSection extends React.Component<any, ResultsSectionState> {
  nodeMain: any;
  nodeSub: any;
  nodeList: any;
  constructor(props: any) {
    super(props);
    this.state = {
      mainDropdownOptions: [],
      subDropdownOptions: [],
      selectedMainOption: "",
      selectedSubOption: "",
      isMainDropdownOpen: false,
      isSubDropdownOpen: false,
      tipsData: [],
      foodsData: [],
      productsData: [],
      dataToDisplay: [],
      openList: false,
      storageDataState: {},
      metaResponseState: {},
      accordionItemsState: "collapsed",
      valueToSearch: "",
      isSaveOpen: false,
      tagsListState: [],
      isDuplicateTestCase: false,
      currentTestCaseName: "",
      saveButtonType: "",
      isOpenMessageStrip: false,
      isDifferenceOpen: false,
      initialInputState: {},
      initialResultsState: [],
      isSearch: false,
      inputState: {},
      isApiFailed: false,
      ApiFailedMessage: "",
    };
  }

  componentDidUpdate = () => {
    if (this.state.openList) {
      const concernedElement: Element | any = document.querySelector(
        ".section-options-wrapper"
      );
      // attach/remove event handler
      document.addEventListener("click", (event) => {
        if (!concernedElement?.contains(event.target)) {
          this.setState({
            openList: false,
          });
        }
      });
    }

    const { metaResponseState, inputState } = this.state;

    const {
      metaResponseProps,
      initialInput,
      initialResults,
      isViewMode,
      isEditMode,
      inputProps,
    } = this.props;

    if (metaResponseState !== metaResponseProps) {
      this.setState({
        metaResponseState: metaResponseProps,
      });
      let mainDropdownArray: any = [];

      const data =
        metaResponseProps?.data?.getMetaRecommendation?.metadata ||
        metaResponseProps?.data?.getMetaRecommendationById?.metadata;
      if (!_.isEmpty(data)) {
        const tips = _.pick(data, ["content"])?.content;
        const foods = _.pick(data, ["food"])?.food;
        const products = _.pick(data, ["product"])?.product;
        tips && mainDropdownArray.push("Tips");
        foods && mainDropdownArray.push("Foods");
        products && mainDropdownArray.push("Products");

        tips &&
          Object.values(tips).forEach((value, index) => {
            const valueTips: any = Object(value);
            Object.keys(valueTips).forEach((keyOfTips) => {
              if (keyOfTips === "stage_name") {
                const tempValue = valueTips[keyOfTips];
                if (!/\d/.test(tempValue)) {
                  delete valueTips[keyOfTips];
                  valueTips[keyOfTips] = index + 1 + " - " + tempValue;
                }
              }
            });
          });

        products &&
          Object.values(products).forEach((value, index) => {
            const valueProducts: any = Object(value);
            Object.keys(valueProducts).forEach((keyOfProducts) => {
              if (keyOfProducts === "stage_name") {
                const tempValue = valueProducts[keyOfProducts];
                if (!/\d/.test(tempValue)) {
                  delete valueProducts[keyOfProducts];
                  valueProducts[keyOfProducts] = index + 1 + " - " + tempValue;
                }
              }
            });
          });

        foods &&
          Object.values(foods).forEach((value, index) => {
            const valueFoods: any = Object(value);
            Object.keys(valueFoods).forEach((keyOfFoods) => {
              if (keyOfFoods === "stage_name") {
                const tempValue = valueFoods[keyOfFoods];
                if (!/\d/.test(tempValue)) {
                  delete valueFoods[keyOfFoods];
                  valueFoods[keyOfFoods] = index + 1 + " - " + tempValue;
                }
              }
            });
          });

        if (!_.isEmpty(foods)) {
          for (const [key, valueObj] of foods && Object.entries(foods)) {
            const valueStage: any = Object(valueObj)?.stage_name;
            const valueData: any = Object(valueObj)?.stage_data;

            if (valueStage === "2 - Final Food") {
              valueData.forEach((element: any) => {
                const temp = element.data.eat;
                element.data.eat = [];
                temp.forEach((item: any) => {
                  element.data.eat.push(item.lookup + " - " + item.foods);
                });
              });
            }
          }
        }

        let subDropdownArray: any = [];

        for (const [key, value] of products && Object.entries(products)) {
          const valueStage: any = Object(value)?.stage_name;

          valueStage && subDropdownArray.push(valueStage);
        }

        let defaultProductStage: any = _.last(subDropdownArray);
        for (const [key, valueObj] of products && Object.entries(products)) {
          const valueStage: any = Object(valueObj)?.stage_name;
          const valueData: any = Object(valueObj)?.stage_data;
          if (valueStage === defaultProductStage) {
            this.setState({ dataToDisplay: valueData });
          }
        }

        // let defaultProductStage: any = _.last(arr);
        // for (const [key, valueObj] of products && Object.entries(products)) {
        //   const valueStage: any = Object(valueObj)?.stage_name;
        //   const valueData: any = Object(valueObj)?.stage_data;
        //   if (valueStage === defaultProductStage) {
        //     this.setState({ dataToDisplay: valueData });
        //   }
        // }

        const answersObj: any = localStorage.getItem("answersObj");
        const parsedAnswersObj: any = this.setState({
          tipsData: tips,
          foodsData: foods,
          productsData: products,
          mainDropdownOptions: mainDropdownArray,
          subDropdownOptions: subDropdownArray,
          selectedSubOption: defaultProductStage,
          selectedMainOption: "Products",
        });
      } else {
        this.setState({
          dataToDisplay: [],
        });
      }
    }

    if (this.state.isMainDropdownOpen) {
      document.addEventListener("click", this.handleMainOutsideClick, true);
    } else {
      document.removeEventListener("click", this.handleMainOutsideClick, false);
    }

    if (this.state.isSubDropdownOpen) {
      document.addEventListener("click", this.handleSubOutsideClick, true);
    } else {
      document.removeEventListener("click", this.handleSubOutsideClick, false);
    }
  };

  handleClose = () => {
    this.setState({
      openList: false,
    });
  };

  handleOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.nodeList) {
      if (this.nodeList.contains(e.target)) {
        return;
      }
      this.handleClose();
    }
  };

  handleMainClose = () => {
    this.setState({
      isMainDropdownOpen: false,
    });
  };

  handleSubClose = () => {
    this.setState({
      isSubDropdownOpen: false,
    });
  };

  handleMainOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.nodeMain) {
      if (this.nodeMain.contains(e.target)) {
        return;
      }
      this.handleMainClose();
    }
  };

  handleSubOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.nodeSub) {
      if (this.nodeSub.contains(e.target)) {
        return;
      }
      this.handleSubClose();
    }
  };
  handleMainInputChange = (value: any) => {
    const { tipsData, foodsData, productsData } = this.state;

    let mainOption: any = {};
    let arr: any = [];
    if (value === "Products") {
      mainOption = { ...productsData };
    } else if (value === "Tips") {
      mainOption = { ...tipsData };
    } else {
      mainOption = { ...foodsData };
    }
    for (const [key, value] of Object.entries(mainOption)) {
      const valueStage: any = Object(value).stage_name;
      valueStage && arr.push(valueStage);
    }

    let defaultStage: any = _.last(arr);
    for (const [key, valueObj] of Object.entries(mainOption)) {
      const valueStage: any = Object(valueObj).stage_name;
      const valueData: any = Object(valueObj).stage_data;
      if (valueStage === defaultStage) {
        this.setState({ dataToDisplay: valueData });
      }
    }

    this.setState({
      selectedMainOption: value,
      isMainDropdownOpen: false,
      subDropdownOptions: arr,
      selectedSubOption: defaultStage,
    });
  };
  handleMainDropDown = () => {
    this.setState({
      isMainDropdownOpen: !this.state.isMainDropdownOpen,
    });
  };
  handleSubDropDown = () => {
    this.setState({
      isSubDropdownOpen: !this.state.isSubDropdownOpen,
    });
  };

  handleSubInputChange = (value: any) => {
    const { tipsData, foodsData, productsData, selectedMainOption } =
      this.state;
    if (selectedMainOption === "Products") {
      for (const [key, valueObj] of Object.entries(productsData)) {
        const valueStage: any = Object(valueObj).stage_name;
        const valueData: any = Object(valueObj).stage_data;
        if (valueStage === value) {
          this.setState({
            dataToDisplay: valueData,
          });
        }
      }
    } else if (selectedMainOption === "Foods") {
      for (const [key, valueObj] of Object.entries(foodsData)) {
        const valueStage: any = Object(valueObj).stage_name;
        const valueData: any = Object(valueObj).stage_data;
        if (valueStage === value) {
          this.setState({ dataToDisplay: valueData });
        }
      }
    } else {
      for (const [key, valueObj] of Object.entries(tipsData)) {
        const valueStage: any = Object(valueObj).stage_name;
        const valueData: any = Object(valueObj).stage_data;
        if (valueStage === value) {
          this.setState({ dataToDisplay: valueData });
        }
      }
    }
    this.setState({
      selectedSubOption: value,
      isSubDropdownOpen: false,
    });
  };

  handleExport = (e: any) => {
    const { metaResponseState, initialInputState, currentTestCaseName } =
      this.state;
    let inputObj = localStorage.getObj("answersObj");
    let testName =
      this.props.testCaseName !== ""
        ? this.props.testCaseName.replaceAll(" ", "_")
        : "New_Test_Case";
    var inputs = !_.isEmpty(inputObj)
      ? inputObj
      : JSON.parse(metaResponseState?.data?.getMetaRecommendationById?.inputs);
    var metaData =
      metaResponseState?.data?.getMetaRecommendation?.metadata ||
      metaResponseState?.data?.getMetaRecommendationById?.metadata;
    var output =
      metaResponseState?.data?.getMetaRecommendation?.recommendations ||
      metaResponseState?.data?.getMetaRecommendationById?.output;
    var obj: any = [
      {
        input: inputs,
        metaData: metaData,
        output: output,
      },
    ];
    var data: string =
      "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(obj));

    let linkElement = document.createElement("a");
    linkElement.setAttribute("href", "data:" + data);
    linkElement.setAttribute("download", `${testName}.json`);
    linkElement.click();
    this.setState({
      openList: false,
    });
  };

  handleSave = (buttonType: string) => {
    const { metaResponseState, saveButtonType } = this.state;
    const { testCaseName, creator } = this.props;
    const id: any = generateUniqueId({
      length: 32,
      useLetters: true,
      useNumbers: true,
    });
    const answers: any = localStorage.getItem("answersObj");
    const metaResult: any = localStorage.getItem("meta_result");
    let parsedMetaResult: any = JSON.parse(metaResult);
    const userName = getAdminEmail();
    const tagsList = getTagsList();

    let obj = {
      test_id: id,
      user: userName,
      inputs: answers,
      output: JSON.stringify(
        parsedMetaResult?.data?.getMetaRecommendation?.recommendations ||
          parsedMetaResult?.data?.getMetaRecommendationById?.recommendations
      ),
      creator: saveButtonType === "create" ? userName : creator,
      tags: tagsList,
      modified_date: new Date(),
      metadata: JSON.stringify(
        parsedMetaResult?.data?.getMetaRecommendation?.metadata ||
          parsedMetaResult?.data?.getMetaRecommendationById?.metadata
      ),
    };
    this.setState({
      isSaveOpen: true,
      tagsListState: tagsList,
      saveButtonType: buttonType,
      currentTestCaseName: buttonType === "create" ? "" : testCaseName,
      isDuplicateTestCase: false,
    });
    // handleCreateTestScenarioAPI(obj);
  };

  omitDeep = (data: any) => {
    let self = this;
    _.forEach(data, function (value, key) {
      if (_.isObject(value)) {
        self.omitDeep(value);
      } else if (key === "__typename") {
        delete data[key];
      }
    });
    return data;
  };

  handleCreateTest = (testName: string) => {
    const { metaResponseState, tagsListState, saveButtonType } = this.state;
    const { creator } = this.props;
    const metaResult: any = localStorage.getItem("meta_result");
    let parsedMetaResult: any = JSON.parse(metaResult);
    const answers: any = localStorage.getItem("answersObj");
    const userName = getAdminEmail();
    let recoOutput: any =
      parsedMetaResult?.data?.getMetaRecommendation?.recommendations ||
      parsedMetaResult?.data?.getMetaRecommendationById?.output;

    const updatedOutput: any = this.omitDeep(recoOutput);
    // const tagsList = getTagsList();

    let obj = {
      test_id: testName,
      user: userName,
      inputs: answers,
      output: JSON.stringify(updatedOutput),
      creator:
        saveButtonType === "create" || _.isEmpty(creator) ? userName : creator,
      tags: tagsListState,
      modified_date: new Date(),
      metadata: JSON.stringify(
        parsedMetaResult?.data?.getMetaRecommendation?.metadata ||
          parsedMetaResult?.data?.getMetaRecommendationById?.metadata
      ),
    };

    const createTestResponse =
      saveButtonType === "create"
        ? handleCreateTestScenarioAPI(obj, this.props)
        : updateTestScenario(obj, this.props);

    createTestResponse.then((response: any) => {
      if (response?.status === 200) {
        localStorage.setItem("testCaseName", testName);
        localStorage.removeItem("isEdit");
        const answers: any = localStorage.getItem("answersObj");
        const parsedAnswers: any = JSON.parse(answers);
        this.setState(
          {
            isSaveOpen: false,
            isDuplicateTestCase: false,
            isOpenMessageStrip: true,
            initialResultsState: updatedOutput,
            initialInputState: parsedAnswers,
          },
          () => {
            setTimeout(() => {
              this.setState({
                isOpenMessageStrip: false,
              });
            }, 3000);
            if (this.props.handleViewMode) {
              this.props.handleViewMode(testName);
            }
          }
        );
      }
      if (response?.status === 400 && response?.message === "Test Exists") {
        this.setState({
          isDuplicateTestCase: true,
        });
      }
      if (response?.error === true && response?.status !== 400) {
        this.setState(
          {
            isApiFailed: true,
            ApiFailedMessage: response?.message,
            isSaveOpen: false,
            isDuplicateTestCase: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                isApiFailed: false,
                ApiFailedMessage: "",
              });
            }, 3000);
          }
        );
      }

      // if()
    });
  };

  handleAccordionState = () => {
    const { accordionItemsState } = this.state;
    this.setState({
      openList: false,
    });

    if (accordionItemsState === "collapsed") {
      const accordionButtonElement: Element | any = document.querySelectorAll(
        ".accordion_results_button"
      );
      accordionButtonElement.forEach((element: any) => {
        element.setAttribute("aria-expanded", "true");
      });
      const accordionPanelElement: Element | any = document.querySelectorAll(
        ".accordion_results_panel"
      );
      accordionPanelElement.forEach((element: any) => {
        element.removeAttribute("hidden");
      });
      this.setState({
        accordionItemsState: "expanded",
      });
    }
    if (accordionItemsState === "expanded") {
      const accordionButtonElement: Element | any = document.querySelectorAll(
        ".accordion_results_button"
      );
      accordionButtonElement.forEach((element: any) => {
        element.setAttribute("aria-expanded", "false");
      });
      const accordionPanelElement: Element | any = document.querySelectorAll(
        ".accordion_results_panel"
      );
      accordionPanelElement.forEach((element: any) => {
        element.setAttribute("hidden", "true");
      });
      this.setState({
        accordionItemsState: "collapsed",
      });
    }
  };
  handleSearch = (valueToSearch: any) => {
    if (valueToSearch.length > 0) {
      this.setState({
        isSearch: true,
      });
    } else {
      this.setState({
        isSearch: false,
      });
    }
  };

  handleCross = (e: any) => {
    if (this.state.isSearch) {
      this.setState({
        valueToSearch: "",
      });
    }
    this.setState({
      isSearch: false,
    });
  };
  render() {
    const {
      mainDropdownOptions,
      selectedMainOption,
      selectedSubOption,
      isMainDropdownOpen,
      subDropdownOptions,
      isSubDropdownOpen,
      dataToDisplay,
      accordionItemsState,
      valueToSearch,
      isSaveOpen,
      metaResponseState,
      tagsListState,
      isDuplicateTestCase,
      currentTestCaseName,
      saveButtonType,
      isOpenMessageStrip,
      isDifferenceOpen,
      initialResultsState,
      initialInputState,
      isSearch,
      isApiFailed,
    } = this.state;

    const {
      metaResponseProps,
      isViewMode,
      isEditMode,
      initialInput,
      initialResults,
      inputProps,
      testCaseStatus,
      testCaseStatusIsSet,
    } = this.props;

    let isArrayOfObjects: boolean =
      !isEmpty(dataToDisplay) && _.every(dataToDisplay, _.isObject);
    let isArrayOfStrings: boolean =
      !isEmpty(dataToDisplay) && _.every(dataToDisplay, _.isString);
    let isSelectedMainOption: boolean =
      selectedMainOption === "Foods" ||
      selectedMainOption === "Products" ||
      selectedMainOption === "Tips"
        ? true
        : false;
    let isSelectedSubOption: boolean =
      selectedSubOption === "1 - Scored Content" ||
      selectedSubOption === "2 - Final Content" ||
      selectedSubOption === "4 - Final Products" ||
      selectedSubOption === "1 - Before Restrictions" ||
      selectedSubOption === "2 - Final Food"
        ? true
        : false;

    let filteredData: any = [];
    if (valueToSearch?.trim()?.length > 1) {
      if (isArrayOfStrings) {
        const filteredResult = dataToDisplay?.filter(
          (item: any) =>
            item &&
            item?.toLowerCase()?.includes(valueToSearch?.trim()?.toLowerCase())
        );
        filteredData = [...filteredResult];
      }
      if (isArrayOfObjects) {
        if (
          selectedMainOption === "Products" &&
          selectedSubOption === "2 - Scored Products"
        ) {
          const filteredScoredResult = dataToDisplay?.filter(
            (item: any) =>
              (item &&
                item?.prod_name
                  ?.toLowerCase()
                  ?.includes(valueToSearch?.trim()?.toLowerCase())) ||
              (item &&
                item?.prod_id
                  ?.toLowerCase()
                  ?.includes(valueToSearch?.trim()?.toLowerCase()))
          );
          filteredData = [...filteredScoredResult];
        } else if (
          selectedMainOption === "Foods" &&
          selectedSubOption === "2 - Final Food"
        ) {
          let filteredFinalResult = dataToDisplay.map((element: any) => {
            return {
              ...element,
              data:
                element?.data?.eat?.filter((subElement: any) =>
                  subElement
                    ?.toLowerCase()
                    ?.includes(valueToSearch?.trim()?.toLowerCase())
                ).length > 0 ||
                element?.data?.avoid?.filter((subElement: any) =>
                  subElement
                    ?.toLowerCase()
                    ?.includes(valueToSearch?.trim()?.toLowerCase())
                ).length > 0
                  ? element.data
                  : [],
            };
          });
          filteredData = [...filteredFinalResult];
        } else {
          let needStateFilteredData = dataToDisplay.map((element: any) => {
            //remove condition in return for data in order to get  filtered nested results
            return {
              ...element,
              data:
                element?.data?.filter((subElement: any) =>
                  subElement
                    ?.toLowerCase()
                    ?.includes(valueToSearch?.trim()?.toLowerCase())
                ).length > 0
                  ? element.data
                  : [],
            };
          });
          const needStateFilteredResult = needStateFilteredData.filter(
            (item: any) => item && item?.data?.length > 0
          );
          filteredData = [...needStateFilteredResult];
        }
      }
    }

    let resultsToDisplay: any =
      valueToSearch?.trim()?.length > 1 ? filteredData : dataToDisplay;

    return (
      <>
        {/* Difference pop-up starts */}
        <DifferencePopup
          open={isDifferenceOpen}
          close={() => {
            this.setState({
              isDifferenceOpen: false,
            });
          }}
          initialInput={
            _.isEmpty(initialInputState) ? initialInput : initialInputState
          }
          initialResults={
            _.isEmpty(initialResultsState)
              ? initialResults
              : initialResultsState
          }
        />
        {/* Difference pop-up ends */}

        {isApiFailed ? (
          <MessageStrip
            messageText={"Something went wrong. Try again or start over"}
            error
          />
        ) : null}

        {/* Save test-case pop-up starts */}
        {isSaveOpen && (
          <SaveTestCasePopup
            close={() => {
              this.setState({
                isSaveOpen: false,
              });
            }}
            open={isSaveOpen}
            save={(input: string) => {
              this.handleCreateTest(input);
            }}
            tagsList={tagsListState}
            isDuplicateTestCase={isDuplicateTestCase}
            currentTestCaseName={currentTestCaseName}
            buttonType={saveButtonType}
            //save={()=>{this.handleCreateTestAPI()}}
          />
        )}

        {/* Save test-case pop-up ends */}

        {/* Test Case Saved Message Starts */}
        {isOpenMessageStrip ? (
          <MessageStrip messageText={"The Test Case has been saved"} />
        ) : null}
        {/* Test Case Saved Message Ends */}
        <div className={`results-area section pull-left `}>
          {/* <div className="title">Get Recommendations here</div> */}
          <div className="inner-wrapper">
            <div className="title-header">
              <div className="title">Results</div>
              <div className="main-input">
                <div className="search-wrapper">
                  <InputField
                    type={"text"}
                    placeHolder={"Search recommendations"}
                    className={"custom-input"}
                    handleInputChange={(evt: any) => {
                      this.handleSearch(evt.target.value.toLowerCase());
                      this.setState({
                        valueToSearch: evt.target.value,
                      });
                    }}
                    inputValue={valueToSearch}
                  />
                  <div
                    className={
                      isSearch ? "icon cross-icon" : "icon search-icon"
                    }
                    onClick={(e) => this.handleCross(e)}
                  ></div>
                </div>
                {!_.isEmpty(metaResponseState?.data) && (
                  <div
                    className="section-options-wrapper"
                    onClick={(e) => {
                      this.setState({
                        openList: !this.state.openList,
                      });
                      e?.stopPropagation();
                    }}
                  >
                    <span className="icon three-dot-icon" />
                    <div className="indicator"></div>
                    {isEditMode &&
                      testCaseStatusIsSet &&
                      (testCaseStatus ? (
                        <div className="indicator green"></div>
                      ) : (
                        <div className="indicator orange"></div>
                      ))}
                    <div
                      ref={(nodeList) => {
                        this.nodeList = nodeList;
                      }}
                      className={
                        this.state.openList
                          ? "options-view"
                          : "options-view hide"
                      }
                    >
                      <div
                        className={isEditMode ? "option" : "option hide"}
                        onClick={() => {
                          this.setState({
                            isDifferenceOpen: true,
                          });
                        }}
                      >
                        View Differences
                        {testCaseStatusIsSet &&
                          (testCaseStatus ? (
                            <div className="indicator green"></div>
                          ) : (
                            <div className="indicator orange"></div>
                          ))}
                        {/* <div className="indicator orange"></div> */}
                      </div>
                      <div
                        className="option"
                        onClick={(e) => this.handleExport(e)}
                      >
                        Export JSON
                      </div>

                      {isArrayOfObjects && (
                        <div
                          className="option"
                          onClick={this.handleAccordionState}
                        >
                          {accordionItemsState === "expanded" &&
                            "Collapse all Results"}

                          {accordionItemsState === "collapsed" &&
                            "Expand all Results"}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {/* <div className="title">
              <div className="tab">Foods</div>
              <div className="tab active">Products</div>
              <div className="tab">Tips</div>
            </div> */}
            </div>
            {/* Filter Area Start */}
            <div
              className={
                _.isEmpty(metaResponseState?.data)
                  ? "filter-area hide"
                  : "filter-area"
              }
            >
              <div className="dropdowns-wrapper">
                <div className="filter-dropdown-container ">
                  <div
                    className={
                      !_.isEmpty(inputProps) && inputProps.short_survey === 1
                        ? "dropdown-input disabled"
                        : "dropdown-input"
                    }
                    onClick={this.handleMainDropDown}
                  >
                    <InputField
                      type={""}
                      placeHolder={""}
                      className={
                        "custom-input ellipsis no-focus no-caplitalize active"
                      }
                      handleInputChange={() => {}}
                      inputValue={selectedMainOption}
                      errorMsg={"Please select an option to continue"}
                      isError={false}
                      readOnly
                    />
                    <div className={"arrowDown"}></div>
                  </div>
                  <div
                    ref={(nodeMain) => {
                      this.nodeMain = nodeMain;
                    }}
                    className={
                      isMainDropdownOpen
                        ? "dropdown-list-area"
                        : "dropdown-list-area hide"
                    }
                  >
                    <div className="list-view">
                      {mainDropdownOptions.map((item: any) => (
                        <div
                          className={
                            selectedMainOption === item ? "list active" : "list"
                          }
                          onClick={() => this.handleMainInputChange(item)}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="filter-dropdown-container">
                  <div
                    className="dropdown-input"
                    onClick={this.handleSubDropDown}
                  >
                    <InputField
                      type={""}
                      placeHolder={""}
                      className={
                        "custom-input ellipsis no-focus no-caplitalize active"
                      }
                      handleInputChange={(evt) => {
                        // this.handleInputChange(evt);
                      }}
                      inputValue={selectedSubOption}
                      errorMsg={"Please select an option to continue"}
                      isError={false}
                      readOnly
                    />
                    <div className={"arrowDown"}></div>
                  </div>
                  <div
                    ref={(nodeSub) => {
                      this.nodeSub = nodeSub;
                    }}
                    className={
                      isSubDropdownOpen
                        ? "dropdown-list-area"
                        : "dropdown-list-area hide"
                    }
                  >
                    <div className="list-view">
                      {subDropdownOptions.map((item: any) => (
                        <div
                          className={
                            selectedSubOption === item ? "list active" : "list"
                          }
                          onClick={() => this.handleSubInputChange(item)}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Filter Area Ends */}

            {/* Results Container Start */}

            <div
              className={
                _.isEmpty(metaResponseState?.data)
                  ? "custom-accordion for-no-results"
                  : "custom-accordion"
              }
            >
              {/* Search Information Area Starts */}
              {valueToSearch?.trim()?.length > 1 && (
                <div className="results-search-info">
                  {filteredData.length > 0
                    ? `Showing results for "${valueToSearch}"`
                    : `No results for "${valueToSearch}"`}
                </div>
              )}
              {/* Search Information Area Ends */}

              {/* Results With Accordion Starts */}

              {isArrayOfObjects && (
                <Accordion allowZeroExpanded={true}>
                  {/* Accordion Area For Scored Products Starts */}
                  {selectedMainOption === "Products" &&
                    selectedSubOption === "2 - Scored Products" &&
                    resultsToDisplay &&
                    resultsToDisplay.length > 0 &&
                    resultsToDisplay.map(
                      (item: any) =>
                        item && (
                          <AccordionItem>
                            <AccordionItemButton className="accordion_results_button">
                              <div className="item-btn-wrapper">
                                <div className="question-title">
                                  {item.prod_id + "-" + item.prod_name}
                                </div>
                                <div className={"handleArrow"}></div>
                              </div>
                            </AccordionItemButton>
                            <AccordionItemPanel className="accordion_results_panel">
                              <div className="results-details-wrapper">
                                <div className="product-details">
                                  <div className="prod-data">
                                    prod_name : {item.prod_name}
                                  </div>
                                  <div className="prod-data">
                                    prod_id : {item.prod_id}
                                  </div>
                                  <div className="prod-data">
                                    score :{item.score}
                                  </div>
                                  <div className="prod-data">
                                    score_calculations:
                                    {item.score_calculations &&
                                      item.score_calculations.length > 0 &&
                                      item.score_calculations.map(
                                        (element: any) => <div>{element} </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </AccordionItemPanel>
                          </AccordionItem>
                        )
                    )}
                  {/* Accordion Area For Scored Products Ends */}

                  {/* Accordion Area For Final Food Starts */}
                  {selectedMainOption === "Foods" &&
                    selectedSubOption === "2 - Final Food" &&
                    resultsToDisplay &&
                    resultsToDisplay.length > 0 &&
                    resultsToDisplay.map(
                      (item: any) =>
                        item &&
                        _.isObject(item.data) &&
                        (!_.isEmpty(item.data.avoid) ||
                          !_.isEmpty(item.data.eat)) && (
                          <AccordionItem>
                            <AccordionItemButton className="accordion_results_button">
                              <div className="item-btn-wrapper">
                                <div className="question-title">
                                  {getNeedStateName(item.needstate)}
                                </div>
                                <div className={"handleArrow"}></div>
                              </div>
                            </AccordionItemButton>
                            <AccordionItemPanel className="accordion_results_panel">
                              {item.data.eat && item.data.eat.length > 0 && (
                                <>
                                  <div className="results-list-view-subheading">
                                    Eat
                                  </div>
                                  <div className="results-list-view for-foodtips">
                                    {item.data.eat.map((element: any) => (
                                      <div className="list">{element}</div>
                                    ))}
                                  </div>
                                </>
                              )}
                              {item.data.avoid && item.data.avoid.length > 0 && (
                                <>
                                  <div className="results-list-view-subheading">
                                    Avoid
                                  </div>
                                  <div className="results-list-view for-foodtips">
                                    {item.data.avoid.map((element: any) => (
                                      <div className="list">{element}</div>
                                    ))}
                                  </div>
                                </>
                              )}
                              {/* <div className="results-details-wrapper">
                                <div className="product-details">
                                  <div className="prod-data">
                                    prod_name : {item.prod_name}
                                  </div>
                                  <div className="prod-data">
                                    prod_id : {item.prod_id}
                                  </div>
                                  <div className="prod-data">
                                    score :{item.score}
                                  </div>
                                  <div className="prod-data">
                                    score_calculations:
                                    {item.score_calculations &&
                                      item.score_calculations.length > 0 &&
                                      item.score_calculations.map(
                                        (element: any) => <div>{element} </div>
                                      )}
                                  </div>
                                </div>
                              </div> */}
                            </AccordionItemPanel>
                          </AccordionItem>
                        )
                    )}
                  {/* Accordion Area For Final Food Ends */}

                  {/* Accordion Area For Foods,Tips & Products Starts */}
                  {isSelectedMainOption &&
                    isSelectedSubOption &&
                    resultsToDisplay &&
                    resultsToDisplay.length > 0 &&
                    resultsToDisplay.map(
                      (item: any) =>
                        _.isArray(item.data) &&
                        item.data.length > 0 && (
                          <AccordionItem>
                            <AccordionItemButton className="accordion_results_button">
                              <div className="item-btn-wrapper">
                                <div className="question-title">
                                  {getNeedStateName(item.needstate)}
                                </div>
                                <div className={"handleArrow"}></div>
                              </div>
                            </AccordionItemButton>
                            <AccordionItemPanel className="accordion_results_panel">
                              {item.data && item.data.length > 0 && (
                                <div className="results-list-view for-foodtips">
                                  {item.data.map((element: any) => (
                                    <div className="list">{element}</div>
                                  ))}
                                </div>
                              )}
                            </AccordionItemPanel>
                          </AccordionItem>
                        )
                    )}
                  {/* Accordion Area For Foods,Tips & Products Ends */}
                </Accordion>
              )}

              {/* Results With Accordion Ends */}
              {/* For all Results Without Accordion Starts */}
              {isArrayOfStrings && (
                <div className="results-list-view">
                  {isArrayOfStrings &&
                    resultsToDisplay &&
                    resultsToDisplay.length > 0 &&
                    resultsToDisplay.map((item: string) => (
                      <div className="list">{item}</div>
                    ))}
                </div>
              )}

              {/* For all Results Without Accordion Ends */}

              {/* No results wrapper Start */}
              {this.props.isRunLoad ? (
                <Loader loaderClassName={"loader-wrapper align-middle"} />
              ) : (
                <div
                  className={
                    _.isEmpty(metaResponseState?.data)
                      ? "no-results-wrapper"
                      : "no-results-wrapper hide"
                  }
                >
                  <div className="no-results-msg">
                    Hit ‘Run’ to get the results
                  </div>
                </div>
              )}
              {/* No results wrapper Ends */}
            </div>
            {/* Results Container Start */}
            {!isViewMode && !isEditMode && (
              <div
                className={
                  _.isEmpty(metaResponseProps?.data)
                    ? "bottom-btn-area disabled"
                    : "bottom-btn-area"
                }
              >
                <Button
                  onButtonClick={() => this.handleSave("create")}
                  name={"Save"}
                  className={"app-btn"}
                />
              </div>
            )}
            {isEditMode && (
              <div
                className={
                  _.isEmpty(metaResponseProps?.data)
                    ? "bottom-btn-area mutiple-btn disabled"
                    : "bottom-btn-area mutiple-btn"
                }
              >
                <Button
                  onButtonClick={() => this.handleSave("create")}
                  name={"Save New Test"}
                  className={"app-btn border-btn"}
                />

                <Button
                  onButtonClick={() => this.handleSave("update")}
                  name={"Save New Version"}
                  className={"app-btn"}
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default ResultsSection;
